var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-lg-12 lbv-event-history" },
      [
        _c(
          "b-card",
          { attrs: { header: "Events" } },
          [
            _c(
              "table",
              {
                staticClass: "table b-table table-striped",
                attrs: { cellspacing: "0", "aria-busy": "false" },
              },
              [
                _c(
                  "tr",
                  _vm._l(_vm.eventHistoryFields, function (col) {
                    return _c("th", [
                      _vm._v(
                        "\n            " + _vm._s(col.label) + "\n          "
                      ),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.eventHistory, function (event, index) {
                      return [
                        event.derived_event_closed === "null"
                          ? _c(
                              "tr",
                              {
                                staticClass: "table-is-open",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.rowClicked(index)
                                  },
                                },
                              },
                              [
                                _c("td", { staticClass: "table-status" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(event.status) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(event.derived_event_created)),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.nullFormatter(
                                        event.derived_event_closed
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.durationFormatter(event))),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.typeTranslation(event.Type))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(event.derived_event_code)),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.actionTranslation(
                                        event.crm_business_name
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.nullFormatter(
                                        event.crm_business_created
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            )
                          : _c("tr", { staticClass: "table-is-closed" }, [
                              _c("td", { staticClass: "table-status" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(event.status) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(event.derived_event_created)),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.nullFormatter(
                                      event.derived_event_closed
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.durationFormatter(event))),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.typeTranslation(event.Type))),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(event.derived_event_code)),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.actionTranslation(
                                      event.crm_business_name
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.nullFormatter(
                                      event.crm_business_created
                                    )
                                  )
                                ),
                              ]),
                            ]),
                        _vm._v(" "),
                        event.interaction_flag !== "null"
                          ? _vm._l(
                              event.interaction_flag.split("|"),
                              function (item) {
                                return _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "child-arrow",
                                      attrs: { colspan: "1" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  ↳\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("td", { attrs: { colspan: "3" } }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.split(",")[1]) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { attrs: { colspan: "1" } }, [
                                    _vm._v(
                                      "\n                  App\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { attrs: { colspan: "4" } }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.split(",")[0]) +
                                        "\n                "
                                    ),
                                  ]),
                                ])
                              }
                            )
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "page prev",
                attrs: {
                  variant: "primary",
                  size: "sm",
                  disabled: _vm.pageNumber === 1,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.page.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n        Prev\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "page next",
                attrs: {
                  variant: "primary",
                  size: "sm",
                  disabled: !_vm.hasNextPage,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.page.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n        Next\n      ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "current-page" }, [
              _vm._v("\n        Page: " + _vm._s(_vm.pageNumber) + "\n      "),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }